import React, { useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { LabeledElement } from 'components/form-elements/labels/LabeledElement';
import { MaskedInput } from 'components/form-elements/inputs/MaskedInput';

export const RfidTags = () => {

  const formContext = useFormContext();
  const submitRefOne = useRef(null);
  const submitRefTwo = useRef(null);

  return (
    <LabeledElement label="rfIdTags">
      <Controller
        name="rfIdTagOne"
        control={formContext?.control}
        render={({ field: { onChange, value } }) => (
          <MaskedInput
            name="rfIdTagOne"
            id="rfId-tag-one"
            value={value}
            submitRef={submitRefOne}
            onChange={onChange}
          />
        )}
      />

      <Controller
        name="rfIdTagTwo"
        control={formContext?.control}
        render={({ field: { onChange, value } }) => (
          <MaskedInput
            id="rfId-tag-two"
            value={value}
            submitRef={submitRefTwo}
            onChange={onChange}
          />
        )}
      />

    </LabeledElement>
  );
};
